// extracted by mini-css-extract-plugin
module.exports = {"main":"qS84Ac29","title":"ERS3cz0n"};